import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

import { Icon } from '../iconTypes';

const IconPlay = ({ className = '', color = '#000000', height = 24, title, width = 24 }: Icon) => (
    <AccessibleSVG className={`icon-play ${className}`} height={height} title={title} viewBox="0 0 24 24" width={width}>
        <path className="fill-color" d="M8 5v14l11-7z" fill={color} />
        <path d="M0 0h24v24H0z" fill="none" />
    </AccessibleSVG>
);

export default IconPlay;
